import { useState } from 'react';
import { Button, Checkbox, Input, Popover, Space } from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import type { Editor } from '@tiptap/react';
import { useIsMobile } from '../../hooks/useIsMobile';
import { withTip } from './ToolbarButton';

interface Props {
  editor: Editor;
  active: boolean;
}

/** 連結編輯：以 AntD Popover 取代 window.prompt，可設定新分頁開啟。 */
export default function LinkPopover({ editor, active }: Props) {
  const [open, setOpen] = useState(false);
  const [url, setUrl] = useState('https://');
  const [blank, setBlank] = useState(true);
  const mobile = useIsMobile();

  const onOpen = (v: boolean) => {
    if (v) {
      const attrs = editor.getAttributes('link');
      setUrl((attrs.href as string) ?? 'https://');
      setBlank((attrs.target as string) !== '_self');
    }
    setOpen(v);
  };

  const apply = () => {
    const c = editor.chain().focus().extendMarkRange('link');
    if (!url || url === 'https://') c.unsetLink().run();
    else c.setLink({ href: url, target: blank ? '_blank' : '_self', rel: blank ? 'noopener noreferrer' : null }).run();
    setOpen(false);
  };

  const content = (
    <Space direction="vertical" size="small" className="w-[min(16rem,80vw)]">
      <Input
        autoFocus
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        onPressEnter={apply}
        placeholder="https://example.com"
      />
      <Checkbox checked={blank} onChange={(e) => setBlank(e.target.checked)}>
        在新分頁開啟
      </Checkbox>
      <Space>
        <Button size="small" type="primary" onClick={apply}>
          套用
        </Button>
        <Button
          size="small"
          danger
          onClick={() => {
            editor.chain().focus().extendMarkRange('link').unsetLink().run();
            setOpen(false);
          }}
        >
          移除連結
        </Button>
      </Space>
    </Space>
  );

  return (
    <Popover trigger="click" open={open} onOpenChange={onOpen} content={content} title="連結">
      {withTip(
        mobile,
        '連結',
        <Button
          size={mobile ? 'middle' : 'small'}
          type={active ? 'primary' : 'text'}
          aria-label="連結"
          icon={<LinkOutlined />}
        />,
      )}
    </Popover>
  );
}
